import { ReactNode } from "react";
import { authClient } from "@/lib/auth-client";
import { Navigate, Outlet } from "react-router";

interface AuthenticatedRouteProps {
  children?: ReactNode;
}

export function AuthenticatedRoute({ children }: AuthenticatedRouteProps) {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Render children when provided, otherwise render nested routes via Outlet
  return children ? <>{children}</> : <Outlet />;
}
